export const MARK_AS_VOID_SUCCESS = 'MARK_AS_VOID_SUCCESS';
export const GET_INVOICABLES_FILTER_SUCCESS = 'GET_INVOICABLES_FILTER_SUCCESS';
export const GET_INVOICABLES_SUCCESS = 'GET_INVOICABLES_SUCCESS';
export const GET_NEW_INVOICE_SUCCESS = 'GET_NEW_INVOICE_SUCCESS';
export const CREATE_INVOICE_SUCCESS = 'CREATE_INVOICE_SUCCESS';
export const CREATE_INVOICES_SUCCESS = 'CREATE_INVOICES_SUCCESS';

export const GET_NEW_CREDIT_INVOICE_SUCCESS = 'GET_NEW_CREDIT_INVOICE_SUCCESS';
export const CREATE_CREDIT_INVOICE_SUCCESS = 'CREATE_CREDIT_INVOICE_SUCCESS';

export const GET_INVOICES_SUCCESS = 'GET_INVOICES_SUCCESS';
export const GET_INVOICES_FILTER_SUCCESS = 'GET_INVOICES_FILTER_SUCCESS';

export const GET_NEW_PAYMENT_SUCCESS = 'GET_NEW_PAYMENT_SUCCESS';
export const CREATE_PAYMENT_SUCCESS = 'CREATE_PAYMENT_SUCCESS';

export const GET_PAYMENTS_SUCCESS = 'GET_PAYMENTS_SUCCESS';

export const IMPORT_PAYMENTS_SUCCESS = 'IMPORT_PAYMENTS_SUCCESS';
export const NEW_IMPORT_PAYMENTS_SUCCESS = 'NEW_IMPORT_PAYMENTS_SUCCESS';
export const GET_INVOICE_SUCCESS = 'GET_INVOICE_SUCCESS';

export const TRY_INVOICE_AGAIN_SUCCESS = 'TRY_INVOICE_AGAIN_SUCCESS';
